import {
  UPDATE_PROJECT,
  SET_ROUND,
  UPDATE_INPUT_STATES,
  UPDATE_MY_STATE,
  SUBMIT_MY_STATE,
  FINISHED_STEP,
  UPDATE_USER,
  UPDATE_POLICY_CHOICE_OPTIONS,
  SET_REMOVED_CURRENT_ROUND,
} from '../actions/types';
import Defines from '../Defines';
import { getGlobasSpent } from '../helpers/calculationsHelper';
import { getPolicyChoiceCollaborations, reduceMinistryCollabs } from '../helpers/feedbackHelpers';
import { handleFailedEmit } from '../ws';

let roundId;
let data = [];
let beleidskeuzes = [];

const initialState = {
  myState: {
    buitenlandRead: false,
    SIMULATION_TAX: 'UNCOMPLETED',
    SIMULATION_TAX_2: 'UNCOMPLETED',
    SIMULATION_SPENDING: 'UNCOMPLETED',
    roundNumber: 0,
    globasSpent: 0,
    roundId: 0,
    CBelasting: 0,
    VBelasting: 0,
    VVBelasting: 0,
    CBelastingSW: [],
    VBelastingSW: [],
    VVBelastingSW: [],
    niveau: 'Pro',
    theme: 'red',
    taal: 'Nederlands',
    taxDividence: .57 + (Math.random() * .06),
    inputGlobas: 0,
    arbeidsBelasting: 0,
    samenWerkingAB: [],
    bedrijvenBelasting: 0,
    samenWerkingBB: [],
    ministryCollaborations: {},
    ministerieGlobaVerdeling: {
      // ...ministries
    },
    policyChoices: {},
    oneTimeEffect: {
      economie: 0,
      WG: 0,
      VG: 0,
      CO: 0,
      VV: 0,
    },
    debitCredit: {},
    collaborationMatches: {},
  },
  role: '',
  states: {},
  ministryCollaborations: {},
  policyChoiceCollaborations: {},
  loaded: false,
  beleidskeuzes: [],
  removedCurrentRound: false,
};

let timerId;
let latestRound = 0;
let myLatestState = initialState.myState;

const gameStateInput = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_PROJECT:
      if (payload.gameState) {
        if (state.history) return state;
        const { project, schoolClass, group, gameState } = payload;
        if (project.DefaultDifficultyId) {
          myLatestState.niveau = project.DefaultDifficultyId === 2 ? 'Basic' : 'Pro';
        }
        state.schoolClassId = schoolClass.id;
        if (state.schoolClassId && schoolClass.Language) {
          myLatestState.taal = schoolClass.Language.name;
        }
        state.groupId = group.id;
        if (state.groupId && group.GroupTheme) {
          myLatestState.theme = group.GroupTheme.color;
        }
        const currentRound = gameState.Rounds[gameState.Rounds.length - 1];
        if (currentRound) {
          myLatestState.inputGlobas = currentRound.earnedGlobas;
          if (!roundId) {
            roundId = currentRound.id;
            myLatestState.roundId = currentRound.id;
          }
          myLatestState.roundNumber = currentRound.roundNumber;
          latestRound = state.currentRound = currentRound.roundNumber;
        }
      }
      break;
    case UPDATE_USER:
      if (payload.userDetails) {
        state.role = payload.userDetails.role;
      }
      break;
    case UPDATE_INPUT_STATES:
      // -----
      // See if we have to mark any local debitcredit items as unread
      // -----
      const states = state.states[latestRound];
      if(payload[latestRound] && state.myState.debitCredit && states) {
        // check if any other country has confirmed our debitCredit
        Object.keys(payload[latestRound])
          .forEach((groupId) => {
            const {debitCredit} = payload[latestRound][groupId];
            Object.keys(debitCredit).forEach(key => {
              const dc = debitCredit[key];
              // is type lenenAan/van Land, confirmed and targeting us?
              if (key.indexOf("Land") !== -1 &&
                dc.confirmed &&
                dc.otherCountry === state.myState.theme &&
                // did this state not exist before or was confirmed false before?
                (!states[groupId] || !states[groupId].debitCredit[key] || !states[groupId].debitCredit[key].confirmed)
              ) {
                //find local state and mark unread
                const local = myLatestState.debitCredit[key === 'lenenAanLand' ? 'lenenVanLand' : 'lenenAanLand'];
                if (local && local.amount === dc.amount && local.interest === dc.interest) local.unread = true;
              }
            })
          });
      }
      // If updateOwnGroup flag is true, set myState too
      if (payload.updateOwnGroup && payload.myState) {
        myLatestState = {
          ...myLatestState,
          ...payload.myState,
        };
      }
      Object.entries(payload.states).forEach(([round, groups]) => {
        state.states[round] = {
          ...state.states[round],
          ...groups,
        }
      });
      break;
    case UPDATE_MY_STATE:
      // New round, so reset some state things
      myLatestState = {
        ...myLatestState,
        ...payload,
      };
      break;
    case SUBMIT_MY_STATE:
      if (timerId) {
        clearTimeout(timerId);
      }
      myLatestState = {
        ...myLatestState,
        ...payload,
      };
      break;
    case UPDATE_POLICY_CHOICE_OPTIONS:
      data = payload;
      break;
    case FINISHED_STEP:
      myLatestState = {...payload.myLatestState};
      state.states = {...payload.states};
      break;
    case SET_REMOVED_CURRENT_ROUND:
      state.removedCurrentRound = true;
      console.log(state.removedCurrentRound);
      break;
    case SET_ROUND:
      state.history = payload < latestRound;
      state.currentRound = payload;
      break;
    default:
      return state;
  }

  state.myState = state.history ? state.states[state.currentRound][state.groupId] : myLatestState;
  state.loaded = Object.keys(state.states).length && state.myState.joined;

  if (!state.loaded || !state.states[state.myState.roundNumber]) return {...state, myLatestState};

  if (state.myState.niveau === 'Basic') {
    state.processing = (state.myState.SIMULATION_TAX === 'SUBMITTED' || state.myState.SIMULATION_SPENDING === 'SUBMITTED');
  } else {
    state.processing = (state.myState.SIMULATION_TAX === 'SUBMITTED' || state.myState.SIMULATION_TAX_2 === 'SUBMITTED' || state.myState.SIMULATION_SPENDING === 'SUBMITTED');
  }

  state.processingStepThree = state.myState.SIMULATION_SPENDING === 'SUBMITTED';

  state.preventInputChanges = state.processing || state.history || !state.loaded || state.removedCurrentRound;
  // Set collaboration matches
  state.myState.collaborationMatches = {
    samenWerkingAB: reduceCollabs('samenWerkingAB', 'arbeidsBelasting', state),
    samenWerkingBB: reduceCollabs('samenWerkingBB', 'bedrijvenBelasting', state),
    CBelastingSW: reduceCollabs('CBelastingSW', 'CBelasting', state),
    VVBelastingSW: reduceCollabs('VVBelastingSW', 'VVBelasting', state),
    VBelastingSW: reduceCollabs('VBelastingSW', 'VBelasting', state),
  };

  // Set ministry collaboration matches (previous round)
  state.ministryCollaborations = Defines.i18nMinistries.reduce((collabs, mKey) => {
    collabs[mKey] = reduceMinistryCollabs(mKey, state);
    return collabs;
  }, { ...state.ministryCollaborations });
  state.myState.ministryCollaborations = state.ministryCollaborations;

  // Set policy choice collaboration matches (previous round)
  if (state.myState.niveau === 'Pro') {
    state.policyChoiceCollaborations = getPolicyChoiceCollaborations(state);
  }
  if (Array.isArray(data)) {
    if(data.length) {
      beleidskeuzes = data[state.currentRound === -1 ? data.length - 1 : state.currentRound] || [];
    }
  } else if (typeof data === 'object') {
    beleidskeuzes = data[state.currentRound === -1 ? Object.keys(data).length-1 : state.currentRound] || [];
  }
  if (type === UPDATE_MY_STATE && state.groupId && state.schoolClassId && !state.preventInputChanges && state.role === 'groupleader') {
    state.myState.globasSpent = getGlobasSpent(state, beleidskeuzes);
    emitUpdatedInput(myLatestState, state.groupId, state.schoolClassId);
  }
  return {...state, myLatestState};
};

function reduceCollabs (swKey, key, s) {
  const { roundNumber } = s.myState;
  return s.myState[swKey].reduce((arr, val) => {
    const group = Object.keys(s.states[roundNumber]).find(k => s.states[roundNumber][k].theme === val);
    if (group) {
      if (s.states[roundNumber][group][swKey].includes(s.myState.theme)) {
        if (s.states[roundNumber][group][key] === s.states[roundNumber][s.groupId][key]) {
          arr.push(val);
        }
      }
    }
    return arr;
  }, []);
}

function emitUpdatedInput (myState, groupId, schoolClassId) {
  if (timerId) {
    clearTimeout(timerId);
  }
  timerId = setTimeout(() => {
    if (myState.joined) {
      window.socket.emit('updatedInput', {
        who: groupId,
        schoolClassId,
        room: `simulationgame-${schoolClassId}`,
        input: { ...myState, roundId },
      }, handleFailedEmit);
    }
    timerId = null;
  }, 2000);
}

export default gameStateInput;



// WEBPACK FOOTER //
// ./src/reducers/gameStateInput.js